exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{\n  width:100%;\n}\n.password-help{\n  margin-bottom: 15px;\n}\n.password-btns {\n  float: right;\n}\n.setting-message {\n  width: 100%;\n  text-align: center;\n  padding: 0px 0px 20px 60px;\n  color: blue;\n}\n.setting-error {\n  width: 100%;\n  text-align: center;\n  padding: 0px 0px 20px 60px;\n  color: red;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/myprofile/myprofile.component.css
// module id = ../../../../../src/app/pages/settings/myprofile/myprofile.component.css
// module chunks = main